<template>
  <b-card no-body>
    <b-row>
      <b-col sm="12" cols="12" class=" ">
        <b-card-header>
          <b-card-title>Competition summary</b-card-title>
          <!-- <b-button variant="outline-secondary" size="sm" style="color:#A3A4AE "
          ><small>Download Data</small></b-button
          > -->
        </b-card-header>
        <b-card-body class=" ">
          <div
              class="d-flex flex-wrap align-items-stretch justify-content-between"
          >
            <div class="mb-25 p-2  "
                 style="background: transparent linear-gradient(194deg, rgb(33 33 44 / 26%) 0%, rgb(33 33 44) 65%, #25ECFB 200%) 0% 0% no-repeat padding-box;border-radius: 10px;width: 49%;">
              <b-media no-body class="mb-25">

                <b-media-aside class="mr-75">
                  <b-skeleton
                      width="50px"
                      height="50px"
                      class="rounded-circle"
                      v-if="loading"
                  />
                  <b-avatar
                    v-else
                    rounded
                    size="42"
                    :src="
                      hasOwnNestedProperty(analytics, 'first_place.avatar')
                        ? analytics.first_place.avatar
                        : ''
                    "
                  />
                </b-media-aside>
                <b-media-body class="my-auto">
                  <b-skeleton
                    width="120px"
                    height="20px"
                    class="mb-0"
                    v-if="loading"
                  />
                  <h6 class="mb-0" v-else>
                    {{
                      hasOwnNestedProperty(analytics, 'first_place.first_name')
                          ? analytics.first_place.first_name + ' ' + analytics.first_place.last_name
                          : '-'
                    }}
                  </h6>
                </b-media-body>
              </b-media>
              <small class="my-1">First place</small>
            </div>
            <div class="mb-25 p-2        "
                 style="  background: transparent linear-gradient(194deg, rgb(33 33 44 / 26%) 0%, rgb(33 33 44) 65%, #FBAD25 200%) 0% 0% no-repeat padding-box;border-radius: 10px;width: 49%;">
              <b-skeleton
                  width="40px"
                  height="20px"
                  class="mb-0 "
                  v-if="loading"
              />

              <div class="h1 font-weight-bolder text-white    " v-else>{{
                  summery.participants_count || "0"
                }}
              </div>
              <small>Total participants</small>
            </div>
          </div>
          <div
              class="d-flex flex-wrap justify-content-between align-items-stretch  "

          >
            <div class="my-25 p-2 cardBorderDash">
              <div class="d-flex">
                <div
                    class="d-flex justify-content-between align-items-center"
                    v-if="loading"
                >
                  <b-skeleton width="80px" class="mr-2" height="30px"/>
                  <b-skeleton width="50px" class="mr-1" height="30px"/>
                  <b-skeleton width="50px" height="30px"/>
                </div>
                <template v-else>
                  <div class="h3 mb-25">{{ summery.symbol || "-" }}</div>
                  <span class="fi fi-eu mx-25" v-if="summery.symbol"></span>
                  <span class="fi fi-us" v-if="summery.symbol"></span>
                </template>
              </div>
              <small>Competitions symbols </small>
            </div>
            <div class="my-25 p-2 cardBorderDash">
              <b-skeleton
                  width="40px"
                  height="20px"
                  class="mb-0"
                  v-if="loading"
              />
              <b-badge
                  v-else
                  :variant="summery.active ? 'light-success' : 'light-danger'"
                  class="mb-25"
                >{{ summery.active ? "Active" : "Not active" }}</b-badge
              >
              <br />
              <small>Competition status</small>
            </div>
          </div>
        </b-card-body>
      </b-col>
      <!--      <b-col-->
      <!--        sm="4"-->
      <!--        class="pr-1   d-flex flex-sm-column align-items-sm-end justify-content-between"-->
      <!--      >-->
      <!--        <b-button variant="outline-secondary" size="sm" style="color:#A3A4AE "-->
      <!--          ><small>Download Data</small></b-button-->
      <!--        >-->
      <!--      </b-col>-->
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BDropdown,
  BDropdownItem,
  BButton,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BImg,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardTitle,
    BCardHeader,
    BDropdown,
    BDropdownItem,
    BButton,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BImg,
    BBadge,
    BSkeleton,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      summery: {},
    };
  },
  watch: {
    analytics(val) {
      this.summery = val.summery;
    },
  },
};
</script>

<style></style>
